export const FETCH_TRANSACTIONS_UPCOMING_ALL_BEGIN = 'TRANSACTIONS__FETCH_TRANSACTIONS_UPCOMING_ALL_BEGIN';
export const FETCH_TRANSACTIONS_UPCOMING_ALL_SUCCESS = 'TRANSACTIONS__FETCH_TRANSACTIONS_UPCOMING_ALL_SUCCESS';
export const FETCH_TRANSACTIONS_UPCOMING_ALL_FAILURE = 'TRANSACTIONS__FETCH_TRANSACTIONS_UPCOMING_ALL_FAILURE';

export const FETCH_TRANSACTIONS_PENDING_ALL_BEGIN = 'TRANSACTIONS__FETCH_TRANSACTIONS_PENDING_ALL_BEGIN';
export const FETCH_TRANSACTIONS_PENDING_ALL_SUCCESS = 'TRANSACTIONS__FETCH_TRANSACTIONS_PENDING_ALL_SUCCESS';
export const FETCH_TRANSACTIONS_PENDING_ALL_FAILURE = 'TRANSACTIONS__FETCH_TRANSACTIONS_PENDING_ALL_FAILURE';

export const FETCH_TRANSACTIONS_HISTORY_ALL_BEGIN = 'TRANSACTIONS__FETCH_TRANSACTIONS_HISTORY_ALL_BEGIN';
export const FETCH_TRANSACTIONS_HISTORY_ALL_SUCCESS = 'TRANSACTIONS__FETCH_TRANSACTIONS_HISTORY_ALL_SUCCESS';
export const FETCH_TRANSACTIONS_HISTORY_ALL_FAILURE = 'TRANSACTIONS__FETCH_TRANSACTIONS_HISTORY_ALL_FAILURE';

export const CHANGE_TRANSACTIONS_STATUS_BEGIN = 'TRANSACTIONS__FETCH_TRANSACTIONS_HISTORY_ALL_BEGIN';
export const CHANGE_TRANSACTIONS_STATUS_SUCCESS = 'TRANSACTIONS__FETCH_TRANSACTIONS_HISTORY_ALL_SUCCESS';
export const CHANGE_TRANSACTIONS_STATUS_FAILURE = 'TRANSACTIONS__FETCH_TRANSACTIONS_HISTORY_ALL_FAILURE';

export const IMPORT_TRANSACTIONS_BEGIN = 'TRANSACTIONS__IMPORT_TRANSACTIONS_BEGIN';
export const IMPORT_TRANSACTIONS_SUCCESS = 'TRANSACTIONS__IMPORT_TRANSACTIONS_SUCCESS';
export const IMPORT_TRANSACTIONS_FAILURE = 'TRANSACTIONS__IMPORT_TRANSACTIONS_FAILURE';
